module.exports = __webpack_public_path__ + "bin/404d8101966fc7949a1fb722d44e3393.jpg";